// True while react-snap is prerendering (it sets this UA). During prerender we
// must avoid the WebGL Canvas + HDR environment map: headless GL is flaky and a
// failed HDR fetch throws, blanking the page. The static fallback renders the
// page text + image instead, which is exactly what crawlers should index.
export function isPrerender() {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
}

export function hasWebGL() {
  if (typeof window === 'undefined') return false;
  try {
    const c = document.createElement('canvas');
    const gl =
      c.getContext('webgl2') ||
      c.getContext('webgl') ||
      c.getContext('experimental-webgl');
    if (!gl) return false;
    return !!gl.getParameter(gl.VERSION);
  } catch {
    return false;
  }
}
